import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Lightning Stroke
 */

export default function LightningStrokeIcon(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <path
        clipRule="evenodd"
        d="M16.4844 11.7625L17.5906 7.55625L18 6L16.7125 6.96562L8 13.5V15L10.7594 15.1844L11.775 15.2531L11.5156 16.2375L10.4094 20.4438L10 22L11.2875 21.0344L20 14.5V13L17.2406 12.8156L16.225 12.7469L16.4844 11.7625ZM19 13.9344V14L11.6969 19.475L12.7406 15.5063L13.05 14.3344L11.8438 14.2531L9 14.0625V14L16.3031 8.525L15.2594 12.4938L14.95 13.6656L16.1594 13.7469L19.0031 13.9375L19 13.9344Z"
        fillRule="evenodd"
      />
    </Icon>
  );
}
